import { useState, type ReactNode } from 'react';

declare global {
  interface Window {
    __anjabomOpenExternalURL?: (url: string) => Promise<void>;
  }
}

interface ExternalLinkProps {
  href: string;
  children: ReactNode;
  className?: string;
}

export function ExternalLink({ href, children, className }: ExternalLinkProps) {
  const openInToss = window.__anjabomOpenExternalURL;
  const [failed, setFailed] = useState(false);
  const [copied, setCopied] = useState(false);
  const copyValue = href.startsWith('mailto:') ? href.slice(7).split('?')[0] ?? href : href;

  const open = () => {
    if (!openInToss) return;
    if (!/^(https:\/\/|mailto:)/i.test(href)) {
      setFailed(true);
      return;
    }
    setFailed(false);
    setCopied(false);
    try {
      void openInToss(href).catch(() => setFailed(true));
    } catch {
      setFailed(true);
    }
  };
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(copyValue);
      setCopied(true);
    } catch {
      setCopied(false);
    }
  };

  return <>
    {openInToss
      ? <button className={`${className ?? ''} external-link-button`} type="button" onClick={open}>{children}</button>
      : <a className={className} href={href} target={href.startsWith('https://') ? '_blank' : undefined} rel="noreferrer">{children}</a>}
    {failed ? <span className="external-link-recovery" role="status">
      <span>링크가 열리지 않았어요. 주소를 복사해 직접 열어 주세요.</span>
      <input aria-label="열리지 않은 주소" readOnly value={copyValue} onFocus={(event) => event.currentTarget.select()} />
      <button type="button" onClick={() => void copy()}>{copied ? '주소를 복사했어요' : '주소 복사'}</button>
    </span> : null}
  </>;
}
